/**
 * Appends standard ToolNova UTM tracking parameters to an outbound URL.
 * Used on all affiliate / partner links to measure click-through traffic.
 *
 * Params added:
 *   utm_source   = toolnova
 *   utm_medium   = referral
 *   utm_campaign = tool-listing  (or tool-{slug} when slug is provided)
 */
export function addUtmParams(url: string, toolSlug?: string): string {
  if (!url) return url;
  try {
    const u = new URL(url);
    u.searchParams.set('utm_source', 'toolnova');
    u.searchParams.set('utm_medium', 'referral');
    u.searchParams.set('utm_campaign', toolSlug ? `tool-${toolSlug}` : 'tool-listing');
    return u.toString();
  } catch {
    // If URL parsing fails (e.g. relative URL), return as-is
    return url;
  }
}
